<template>
  <BaseDialogForm
    v-model="showPaymentMethodForm"
    :title="
      editMode
        ? `Edit ${configurationModule.paymentMethod}`
        : `Add ${configurationModule.paymentMethod}`
    "
    :nonFieldErrors="formErrors.non_field_errors"
    maxWidth="600"
  >
    <template #content>
      <v-form v-model="isValid" ref="paymentMethodForm" :key="formCount">
        <v-row class="ma-0">
          <v-col cols="6">
            <InputField
              id="name"
              v-model="paymentMethodDetails.name"
              label="Name"
              name="name"
              :required="true"
              :error-messages="formErrors.name"
              @input="delete formErrors.name"
            />
          </v-col>
          <v-col cols="6">
            <SelectField
              id="type"
              v-model="paymentMethodDetails.type"
              :itemsList="paymentMethodTypeList"
              name="type"
              :label="`${configurationModule.paymentMethod} Type*`"
              itemText="display_value"
              itemValue="value"
              :rules="[(val) => !!val || 'Type is required']"
              :error-messages="formErrors.type"
              @input="delete formErrors.type"
            />
          </v-col>
        </v-row>
      </v-form>
    </template>
    <template #actions>
      <SecondaryButton
        id="paymentMethodReset"
        v-if="!editMode"
        @click="resetForm()"
        class="mr-2"
        name="Reset"
      >
      </SecondaryButton>
      <PrimaryButton
        id="paymentMethodSubmit"
        @click="submitForm()"
        :disabled="!isValid"
        name="Submit"
      >
      </PrimaryButton>
    </template>
  </BaseDialogForm>
</template>

<script>
import { bus } from "@/main.js";
import BaseDialogForm from "@/components/LayoutComponents/BaseDialogForm.vue";
import { configurationModule } from "@/utils/moduleMapping";

export default {
  components: { BaseDialogForm },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    editMode: {
      required: true,
    },
    id: {
      type: Number,
    },
  },
  data() {
    return {
      configurationModule,
      fileInput: null,
      formCount: 0,
      isValid: true,
      paymentMethodDetails: {},
      paymentMethodTypeList: [],
      formErrors: {},
      unitList: [],
    };
  },
  watch: {
    value(val) {
      if (val) {
        this.getPaymentMethodTypeOption();
        if (this.editMode && this.id) {
          this.getPaymentMethodObject(this.id);
        }
      } else {
        this.resetForm();
        this.formErrors = {};
      }
    },
  },
  computed: {
    showPaymentMethodForm: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    resetForm() {
      this.paymentMethodDetails = {};
      this.$refs.paymentMethodForm.reset();
    },
    getPaymentMethodObject(id) {
      this.$api.paymentMethod
        .getPaymentMethodObject(id)
        .then((res) => {
          this.paymentMethodDetails = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getPaymentMethodTypeOption() {
      this.$api.paymentMethod
        .getPaymentMethodTypeOption({ request_type: "form" })
        .then((res) => {
          this.paymentMethodTypeList = res?.data?.payment_type;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    submitForm() {
      if (this.editMode) {
        this.$api.paymentMethod
          .updatePaymentMethodObject({
            id: this.paymentMethodDetails.id,
            data: this.paymentMethodDetails,
          })
          .then(() => {
            bus.$emit("showToastMessage", {
              message: "Payment Method information updated!",
              color: "success",
            });
            this.$emit("refreshList");
            this.showPaymentMethodForm = false;
          })
          .catch((err) => {
            console.log(err);
            this.formErrors = err.data;
          });
      } else {
        this.$api.paymentMethod
          .createPaymentMethodObject(this.paymentMethodDetails)
          .then(() => {
            bus.$emit("showToastMessage", {
              message: "Payment Method created!",
              color: "success",
            });
            this.showPaymentMethodForm = false;
            this.$emit("refreshList");
          })
          .catch((err) => {
            this.formErrors = err.data;
          });
      }
    },
  },
  mounted() {
    if ("id" in this.$route.params) {
      this.getPaymentMethodObject(this.$route.params.id);
    }
  },
};
</script>

<style>
.v-select__slot label {
  z-index: 2;
}
</style>
